// app/shared/components/feedback/HTFBadge.tsx
//
// Thin alias shim over fluxos-lib-ui's canonical FLBadge (kit subpath).
// Verified prop-identical — call sites keep importing HTFBadge unchanged.
// Canonical implementation now lives in fluxos-lib-ui; do not restyle here.
export type {
  FLBadgeProps as HTFBadgeProps,
  FLBadgeSize as HTFBadgeSize,
  FLBadgeVariant as HTFBadgeVariant,
} from "@ogattermayr/fluxos-lib-ui/kit";
export { FLBadge as HTFBadge } from "@ogattermayr/fluxos-lib-ui/kit";
